<template>
  <div>
    <div id="shopify-product-reviews" v-if="this.reviewSource === 'shopify'" :data-id="product.id"></div>
    <div class="yotpo yotpo-main-widget" v-else :data-product-id="product.id" :data-price="product.price" :data-currency="this.currency" :data-name="product.title" :data-url="product.handle" :data-image-url="product.featured_image"></div>
  </div>
</template>

<script>
import { scrollToId } from '@/scripts/helpers/scroll'
export default {
  name: 'ProductReviews',
  props: {
    product: Object,
    customFields: Object
  },
  data () {
    return {
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      currency: window.bvaccel && window.bvaccel.currency,
      scrolled: false
    }
  },
  mounted () {
      if (window.location.search.includes("scroll=review")) {
        this.scrollAfterMutation();
      }
  },
  methods: {
    scrollAfterMutation() {
      const Observer = new MutationObserver((list, observer) => {
        if (!this.scrolled) {
          this.scrolled = true;
          scrollToId(null, "#pdp-reviews");
          observer.disconnect();
        }
      });
     Observer.observe(this.$el, {childList: true,subtree: true});
    }
  }
}
</script>

<style lang="scss">
.yotpo-main-widget.yotpo {

  div, span {
    font-family: $font-family-secondary;
  }

  .yotpo-label-container {
    display: none;

    & + .yotpo-display-wrapper {

      .yotpo-regular-box {
        padding-bottom: 0;
      }
    
      &:after {
        content: 'Read Our Reviews';
        display: block;
        text-align: center;
        font-family: $font-family-primary;
        font-size: rem(28);
        line-height: rem(34);
        color: $color-black-900;
        margin-bottom: 20px;
        @include tablet-up {
          font-size: rem(40);
          line-height: rem(48);
        }
      }
    }
  }

  .write-question-review-buttons-container {
    float: none;
    display: flex;
    justify-content: center;

    .yotpo-icon {
      display: none;
    }
  }
  .yotpo-display-wrapper {
    .bottom-line-items {
      display: flex;
      justify-content: center;
    }
    .yotpo-filter-stars {
      order: 0;
    }
    .reviews-qa-labels-container {
      display: none;
    }
    .avg-score {
      order: 1;
      color: $color-black-700;
      font-family: $font-family-secondary;
      font-size: rem(12);
      font-weight: 400;
      line-height: rem(16);
      width: auto;
      margin-left: 10px;
      padding-top: 0;
      &:after {
        content: ' of 5 Stars';
        font-size: rem(12);
        font-family: $font-family-secondary;
      }
    }
    .yotpo-filter-stars .yotpo-icon {
      font-size: rem(13);
      line-height: rem(13);
    }
  }
  .yotpo-nav .yotpo-active {
    border-color: $color-black-200;
    padding-left: 0;
    padding-right: 0;
  }

  .yotpo-nav-primary {

    @include mobile-only {
      ul {
        width: 100% !important;
        display: flex;
      }

      li {
        flex: 1 0 50%;
        text-align: center;
        margin-right: 0;
      }
    }
  }

  .yotpo-nav-tab {
    margin-bottom: 0;



    .yotpo-nav-wrapper {
      padding: 5px 11px;
      font-weight: 40;
      border-bottom: 1px solid transparent !important;
      transform: translateY(1px);
      * {
        color: $color-black-900 !important;
        font-family: $font-family-primary;
      }
    }
    &.yotpo-active .yotpo-nav-wrapper {
      border-bottom: 1px solid $color-black-900 !important;
    }
  }

  .yotpo-regular-box.yotpo-bottomline-empty-state {
    display: flex;
    flex-direction: column;
  }

  .yotpo-default-button.yotpo-icon-btn {
    background: transparent;
    position: static !important;
    border: 0;
    border-radius: 0;
    color: $color-black-900;
    text-decoration: underline;
    font-family: $font-family-primary;
    &:hover {
      background: transparent;
    }

    .yotpo-icon-button-text {
      color: $color-black-900 !important;
      font-family: $font-family-secondary !important;
      font-size: rem(15);
      font-weight: 400;
      text-decoration: underline;
      text-transform: capitalize;
    }
    .write-question-review-button-text {
      font-family: $font-family-secondary !important;
      font-weight: 400;
      color: $color-black-900;
    }
  }
  .yotpo-review {
    padding: 25px 0 22px;
    margin: 0;

    &.yotpo-regular-box-filters-padding {
      padding: 10px 0 22px;
    }

    @include tablet-up {
      display: grid;
      grid-template-columns: 450px auto;
      margin: 0;
      

      .yotpo-footer {
        grid-column-start: 2;
      }
    }
    .yotpo-footer {
      .yotpo-helpful {
        display: block;
      }
    }

    .yotpo-main {
      margin-top: 0;

      .yotpo-multiple-rating-fields {
        display: none;
      }

      .content-title {
        color: $color-black-700;
      }

      .content-review {
        color: $color-black-700;
        font-size: rem(15);
      }
    }
  }
  .yotpo-stars-and-sum-reviews {
    margin: 0 auto;
  }
  .yotpo-regular-box {
    border-color: $color-black-200;
    &:first-child {
      border-top: 0;
    }
  }
  .yotpo-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    span {
      font-family: $font-family-secondary;
    }
    .yotpo-header-element {
      display: flex !important;
      flex-direction: column;

      @include tablet-up {
        display: grid !important;
        grid-template-columns: repeat(2, 1fr);
      }
      .y-label.yotpo-user-name {
        @include mobile-only {
          order: 3;
        }
        font-family: $font-family-primary;
        font-size: rem(22);
        line-height: rem(29);
        font-weight: 400;
        color: $color-black-900 !important;
        @include tablet-up {
          font-size: rem(28);
          line-height: rem(37);
        }
      }
      .label-with-tooltip {
        order: 10;
      }
      .yotpo-review-stars {
        order: 2;

        .yotpo-icon {
          font-size: rem(11);

          @include tablet-up {
            font-size: rem(12);
          }
        }

        @include mobile-only {
          margin-bottom: 10px;
        }

        .yotpo-user-related-fields {
          margin-top: 20px;
          font-family: $font-family-secondary;
        }
        .yotpo-user-field-description {
          font-style: normal;
        }
      }
      .yotpo-user-title,
      .yotpo-review-date {
        color: $color-black-900 !important;
        font-size: rem(10) !important;
        line-height: rem(14) !important;
        margin-top: 10px;
      }

      .yotpo-review-date {
        @include mobile-only {
          position: absolute;
          bottom: 0;
          right: 0;
          margin-top: 0;
        }
      }
    }
    .yotpo-icon-profile,
    .yotpo-clr {
      display: none !important;
    }
  }


  // -----------
  // Pagination
  // -----------
  .yotpo-pager {
    display: flex;
    position: relative;
    justify-content: center;

    .yotpo-page-element {
      border-radius: 100%;
      display: inline-flex;
      height: 50px;
      width: 50px;
      align-items: center;
      justify-content: center;
      font-family: $font-family-secondary;
      font-size: rem(14);
      line-height: rem(15);
      color: $color-black-600 !important;

      &.yotpo-active {
        border: 1px solid $color-black-900;
        color: $color-black-900 !important;
        font-size: rem(16);
        font-weight: $font-weight-global;
        line-height: rem(18);
      }
    }
  }

  .yotpo_previous,
  .yotpo_next {
    display: inline-flex;
    position: absolute;

    &:before {
      font-size: rem(10);
      border: 4px solid $color-black-900;
      border-top-color: transparent;
      border-bottom-color: transparent;
      content: '';
    }

    &:after {
      color: $color-black-900;
      font-family: $font-family-primary !important;
      font-size: rem(15);
      display: none;
      @include tablet-up {
        display: block;
      }
    }
  }

  .yotpo_previous {
    left: 0;
    &:before {
      border-left-color: transparent;
    }
    &:after {
      content: 'Previous';
      padding-left: 5px;
    }
  }
  .yotpo_next {
    right: 0;
    &:before {
      border-right-color: transparent;
      order: 2;
    }
    &:after {
      order: 1;
      content: 'Next';
      padding-right: 5px;
    }
  }

  .yotpo-reviews-filters {
    border-bottom: 0;

    .filters-container-title {
      font-family: $font-family-secondary;
      font-size: rem(15);
      font-weight: $font-weight-global;
      @include tablet-up {
        padding-bottom: 0;
      }
    }

    .filters-dropdown {

      .yotpo-dropdown-button {
        height: 45px;
        padding: 12px;
      }
      .selected {
        color: $color-black-600;
        font-family: $font-family-secondary;
        font-size: rem(15);
        font-weight: $font-weight-global;
      }
      .yotpo-dropdown {
        top: 45px;
      }
    }
  }

  .yotpo-reviews-header {
    margin: 0;

    @include tablet-up {
      border-bottom: 1px solid $color-black-200;
    }

    .reviews-amount {
      color: $color-black-700;
      font-size: rem(12);
      line-height: rem(16);
      font-weight: $font-weight-global;
    }
  }

  .yotpo-first-review-content {

    .yotpo-default-button {
      background: transparent;
      position: static !important;
      border: 0;
      border-radius: 0;
      color: $color-black-900;
      text-decoration: underline;
      font-family: $font-family-primary;
      color: $color-black-900 !important;
      font-family: $font-family-secondary !important;
      font-size: rem(15);
      font-weight: 400;
      text-decoration: underline;
      text-transform: capitalize;
      &:hover {
        background: transparent;
      }
    }
  }
}
.yotpo-main-widget.yotpo .yotpo-bottomline .yotpo-icon-star, 
.yotpo-main-widget.yotpo .yotpo-bottomline .yotpo-icon-half-star, 
.yotpo-main-widget.yotpo .yotpo-bottomline .yotpo-icon-empty-star, 
.yotpo-main-widget.yotpo .yotpo-review .yotpo-header .yotpo-review-stars .yotpo-icon, 
.yotpo-main-widget.yotpo .yotpo-comment .yotpo-header .yotpo-review-stars .yotpo-icon, 
.yotpo-main-widget.yotpo .yotpo-question .yotpo-header .yotpo-review-stars .yotpo-icon, 
.yotpo-main-widget.yotpo .yotpo-onsite-upload .yotpo-header .yotpo-review-stars .yotpo-icon {
  color: $color-green-slate-300;
}
.yotpo-footer {
  .yotpo-action {
    .yotpo-icon-seperator,
    .y-label {
      display: none;
    }
  }
  .footer-additional-actions {
    display: none !important;
  }
}
</style>
